export interface IRaport {
    name:string;
}

export const  Raports:{ [id: string]: IRaport} = {
    pairings: {name:"Pairings"},
    standings: {name:"Standings"},
    table: {name:"Table"},
};